import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  Dashboard,
  Groups,
  AssignmentTurnedIn,
  ViewModule,
  Assessment,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageWithHeader from "../common/PageWithHeader";
import { LabourDashboard } from "./labour-tracker/LabourDashboard";
import { LabourRegister } from "./labour-tracker/LabourRegister";
import { LabourWorkers } from "./labour-tracker/LabourWorkers";
import { LabourBlocks } from "./labour-tracker/LabourBlocks";
import { LabourReports } from "./labour-tracker/LabourReports";

const COMS_NAVY = "#123456";

const TABS = [
  { label: "Dashboard", icon: <Dashboard sx={{ fontSize: 18 }} /> },
  { label: "Register", icon: <AssignmentTurnedIn sx={{ fontSize: 18 }} /> },
  { label: "Workers", icon: <Groups sx={{ fontSize: 18 }} /> },
  { label: "Blocks", icon: <ViewModule sx={{ fontSize: 18 }} /> },
  { label: "Reports", icon: <Assessment sx={{ fontSize: 18 }} /> },
];

const LabourTrackerHome: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  return (
    <PageWithHeader>
      {/* Header */}
      <Box sx={{ bgcolor: COMS_NAVY, color: "#fff", px: 5, py: 3 }}>
        <Typography
          variant="body2"
          sx={{ color: "rgba(255,255,255,0.6)", cursor: "pointer", mb: 0.5 }}
          onClick={() => navigate("/coms")}
        >
          ← COMS
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mt={1}>
          <Groups sx={{ fontSize: 36 }} />
          <Box>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 700 }}>
              Labour Tracker
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
              Track labour resources, attendance and productivity across sites.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Navigation tabs */}
      <Box sx={{ borderBottom: "1px solid #e0e0e0", bgcolor: "#fff", px: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: 14,
              minHeight: 48,
            },
          }}
        >
          {TABS.map((t, i) => (
            <Tab key={i} label={t.label} icon={t.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box px={5} py={4}>
        {tab === 0 && <LabourDashboard />}
        {tab === 1 && <LabourRegister />}
        {tab === 2 && <LabourWorkers />}
        {tab === 3 && <LabourBlocks />}
        {tab === 4 && <LabourReports />}
      </Box>
    </PageWithHeader>
  );
};

export default LabourTrackerHome;
